import logUtil from 'utils/log'

export default function shouldShowModalOrBannerPostSampleSelectUtil (props) {
  logUtil('shouldShowModalOrBannerPostSampleSelectUtil').debug('props=', props)
  const { shouldShowBanner, shouldShowModal } = props
  return shouldShowBanner || shouldShowModal
}
